import { forwardRef } from "react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

export interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
}

export const FormInput = forwardRef<HTMLInputElement, FormInputProps>(
  ({ className, error, ...props }, ref) => {
    return (
      <Input
        ref={ref}
        className={cn(
          "w-full rounded-lg border border-seaMist/50 bg-pureWhite px-4 py-2.5 text-textBody placeholder:text-textMuted/60 focus:border-oceanBlue focus:ring-oceanBlue/20",
          error && "border-red-400 focus:border-red-500 focus:ring-red-200",
          className
        )}
        aria-invalid={error ? "true" : "false"}
        {...props}
      />
    );
  }
);
FormInput.displayName = "FormInput";
